import * as React from 'react';
import styles from './index.less';
// import { CSSProperties } from 'react';
// import { FUtil } from '@freelog/tools-lib';
// import url from '*.svg';

interface FNodeCoverImageProps {
  /** 图片 URL 字符串，或 webpack import 对象（如 import * as img from 'x.png'） */
  src: string | { default?: string };

  style?: React.CSSProperties;
  className?: string;
}

function FNodeCoverImage({ src, style = {}, className = '' }: FNodeCoverImageProps) {
  const srcStr =
    typeof src === 'string' ? src : (src && typeof src === 'object' && src.default) || '';
  return (
    <div
      className={styles.FNodeCoverImage}
      style={{ ...style, backgroundImage: srcStr ? `url(${srcStr})` : undefined }}
    />
  );
}

export default FNodeCoverImage;
